// extracted by mini-css-extract-plugin
module.exports = {"root":"ProjectList_root__3COtU","listItemLight":"ProjectList_listItemLight__2gUpQ","listItemDark":"ProjectList_listItemDark__Njuly"};